"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReasonsOfConfidence = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const FooterHeading_1 = require("./FooterHeading");
const ROCWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    borderRadius: ['roundedTop', '0px'],
    px: [4, '70px'],
    pt: [4, '40px'],
    pb: [0, '30px'],
    flexBasis: [null, '50%'],
    mr: [null, 4],
    backgroundColor: 'background',
    boxShadow: ['none', 'blockShadow'],
}));
const ROCContent = styled_components_1.default.div(({ theme, theme: { space, media, fontSizes } }) => ({
    marginBottom: space[3],
    listStyle: 'none',
    [media.tablet]: {
        marginBottom: 0,
    },
    li: {
        paddingLeft: '30px',
        marginBottom: space[2],
        position: 'relative',
        '&:before': {
            content: '""',
            position: 'absolute',
            color: 'black',
            left: 0,
            top: '3px',
            width: '20px',
            height: '20px',
            backgroundImage: 'url("/images/svg/Success.svg")',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            [media.tablet]: {
                top: space[1],
                width: '25px',
                height: '25px',
            },
        },
        [media.tablet]: {
            paddingLeft: '35px',
            fontSize: fontSizes[3],
        },
    },
    p: {
        marginBottom: space[1],
        [media.tablet]: {
            marginBottom: space[2],
        },
    },
    a: theme.link.text,
}));
const ReasonsOfConfidence = (_a) => {
    var { title, text, className } = _a, divProps = __rest(_a, ["title", "text", "className"]);
    return (react_1.default.createElement(ROCWrapper, Object.assign({}, divProps, { "data-id": "reasons-of-confidence", className: className }),
        title && react_1.default.createElement(FooterHeading_1.FooterHeading, { "data-id": "title" }, title),
        react_1.default.createElement(ROCContent, { "data-id": "content", dangerouslySetInnerHTML: { __html: text } })));
};
exports.ReasonsOfConfidence = ReasonsOfConfidence;
//# sourceMappingURL=ReasonsOfConfidence.js.map